import { apiFetch } from './client'

export type ProjectStatus = 'active' | 'planned' | 'closed'
export type ProjectTaskState = ' ' | '~' | 'x' | '!'

export interface ProjectConceptBlock {
  kind: 'p' | 'h' | 'li'
  text: string
}

export interface ProjectSprint {
  id: string
  state: string
  goal: string
  done: number
  total: number
  tasks?: ProjectTask[]
}

export interface ProjectCommit {
  hash: string
  subj: string
  author: string
  sprint: string
  ageHours: number
  hotfix?: boolean
}

export interface ProjectTask {
  st: ProjectTaskState
  text: string
  criteria: string
}

export interface ProjectDto {
  id: string
  name: string
  abbr: string
  status: ProjectStatus
  desc: string
  title: string
  concept: ProjectConceptBlock[]
  sprint: ProjectSprint | null
  ahead: {
    vault: number
    platform: number
  }
  lastUpdate: string
  chatAgent: string
  commits: ProjectCommit[]
  tasks: ProjectTask[]
  sprintHistory: ProjectSprint[]
}

export interface ProjectContextDto {
  id: string
  path: string
  content: string
  concept: ProjectConceptBlock[]
}

export interface ProjectContextPreviewLayer {
  id: string
  label: string
  source: string
  estimatedTokens: number
}

export interface ProjectContextPreviewDto {
  id: string
  layers: ProjectContextPreviewLayer[]
  totalEstimatedTokens: number
}

export function projectPath(id: string): string {
  return `/projects/${encodeURIComponent(id)}`
}

export function fetchProjects(): Promise<ProjectDto[]> {
  return apiFetch<ProjectDto[]>('/api/projects')
}

export function fetchProject(id: string): Promise<ProjectDto> {
  return apiFetch<ProjectDto>(`/api/projects/${encodeURIComponent(id)}`)
}

export function fetchProjectContext(id: string): Promise<ProjectContextDto> {
  return apiFetch<ProjectContextDto>(`/api/projects/${encodeURIComponent(id)}/context`)
}

export function fetchProjectContextPreview(id: string): Promise<ProjectContextPreviewDto> {
  return apiFetch<ProjectContextPreviewDto>(`/api/projects/${encodeURIComponent(id)}/context/preview`)
}
